import { useState, useRef, useEffect } from "react";
import { useChatMessages } from "@features/Chat";
import "../style/Chat.scss";

export const ChatModal = ({ product, onClose, user }) => {
  const { messages, loading, sendMessage, loadMessages, page, hasMore } =
    useChatMessages(product?.crm?.id, user);


  const [text, setText] = useState("");
  const listRef = useRef(null);

  // Автоскролл вниз при первой загрузке и новых сообщениях
  useEffect(() => {
    if (!loading && page === 1 && messages.length > 0) {
      const el = listRef.current;
      if (el) el.scrollTop = el.scrollHeight;
    }
  }, [loading, page, messages.length]);

  const handleSend = async () => {
    if (!text.trim()) return;
    await sendMessage(text);
    setText("");
    setTimeout(() => {
      const el = listRef.current;
      if (el) el.scrollTop = el.scrollHeight;
    }, 0);
  };

  // Загрузка старых сообщений
  const handleLoadMore = async () => {
    const el = listRef.current;
    if (!el) return;

    const prevHeight = el.scrollHeight;
    await loadMessages(page + 1);
    requestAnimationFrame(() => {
      const newHeight = el.scrollHeight;
      el.scrollTop = newHeight - prevHeight;
    });
  };

  return (
    <div className="chat-modal">
      <div className="chat-modal__card">
        <div className="chat-modal__header">
          <h3>{product?.crm?.product?.name}</h3>
          <span className="chat-modal__sku">Артикул: {product?.crm?.sku}</span>
          <button className="chat-modal__close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="chat-modal__messages" ref={listRef}>
          {hasMore && (
            <button
              className="chat-modal__loadmore"
              onClick={handleLoadMore}
              disabled={loading}
            >
              {loading ? "Загрузка…" : "Загрузить ещё"}
            </button>
          )}

          {messages.map((msg) => {
            const author = msg.user || msg.userId;
            const isMe = author?._id === user?._id;
            return (
              <div
                key={msg._id}
                className={`chat-row ${isMe ? "from-me" : "from-other"}`}
              >
                {isMe && (
                  <span className="chat-time">
                    {new Date(msg.createdAt).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                )}

                <div className={`chat-message ${msg.pending ? "pending" : ""}`}>
                  <div className="chat-message__header">
                    <b>{author?.name || author?.email || "Без имени"}</b>
                    {author?.roles?.length > 0 && (
                      <span className="chat-message__role">
                        ({author.roles.map((r) => r.name).join(", ")})
                      </span>
                    )}
                  </div>
                  <div className="chat-message__text">{msg.text}</div>
                </div>

                {!isMe && (
                  <span className="chat-time">
                    {new Date(msg.createdAt).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                )}
              </div>
            );
          })}
        </div>

        <div className="chat-modal__input">
          <input
            type="text"
            placeholder="Напишите сообщение..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
          />
          <button onClick={handleSend}>Отправить</button>
        </div>
      </div>
    </div>
  );
};
